import React, {useState} from 'reactn';
import {DeleteOutlined, EditOutlined,} from '@ant-design/icons';
import { Popover, notification, Button, Modal, Input, message, Form, Typography } from 'antd';

import { useFirestore } from 'reactfire';

const SingleShowDisease = (props) => {
    const { TextArea } = Input;
    const { Title } = Typography;

    const [popup, setPopup] = useState(false);
    const [isModalVisible, setModalVisible] = useState(false);
    const [state, setState] = useState({
        note: props.disease_desc,
    })
    const firestore = useFirestore();
    const query = firestore.collection("Diagnosis_records").doc(props.id);

    const deleteteItrem = () => {
        query.delete().then(() => {
            console.log('Successfully Deleted');
            props.deletedRecord();
            notification.open({
                message: 'Record Deleted',
                icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
        })
        // console.log('deleting' , props.id)
    }
    const getValue = e => {
        setState({note: e.target.value});
    }

    const onSubmitEditNote = valform => {
        query.update({['disease_info.note']: valform.note}).then(() => {
            message.success('Disease info updated');
            setModalVisible(false);
            props.deletedRecord();
        });
    }

    return (
        <>
        <li>
            <h4>{props.disease_name}</h4>
            <p>{props.disease_desc}</p>
            <Popover
                content={<a onClick={deleteteItrem}>Delete</a>}
                title="Are you sure you want to delete?"
                trigger="click"
                visible={popup}
                onVisibleChange={() => setPopup(!popup) }
            >
                <DeleteOutlined />
            </Popover>

            
            <EditOutlined style={{cursor: 'pointer'}} onClick={() => setModalVisible(true)} />
        </li>


        <Modal title="Edit disease information" width='500px' footer={null} visible={isModalVisible} onCancel={() => setModalVisible(false)}>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <Title level={4}>{props.disease_name}</Title>
                <a href="#">Upload Image</a>
            </div>
            <Form
                name="editdisease"
                onFinish={onSubmitEditNote}
                initialValues={{
                    ['note']: state.note,
                }}
            >
                <Form.Item
                    style={{marginBottom: '10px'}}
                    name="note"
                >
                    <TextArea onChange={getValue} value={state.note} placeholder="Enter Note" rows={2} />
                </Form.Item>
                <Button type="primary" htmlType="submit">Update</Button>
             </Form>
        </Modal>
        </>
    );
}

export default SingleShowDisease;
